module.exports = __webpack_public_path__ + "static/media/urbangoo03.c5e4a09c.webp";